/**
 * @generated SignedSource<<e34bea812bc4c25dad764db6a767b631>>
 * @relayHash 46d42a7d19ac7c08168ef7ffa53f8463
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bcbf748546e6d06895c02f12e112e0b3241c6d574e7955503cf520ffa998a0f4

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { IssueTransitionModalQuery } from './IssueTransitionModalQuery.graphql';

import enableUiModificationsForItAgentView_provider from '@atlassian/jira-relay-provider/src/enable-ui-modifications-for-it-agent-view.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import shouldFetchAppUserType_provider from '@atlassian/jira-relay-provider/src/jira-ai-fetch-apptype-for-user-assignee.relayprovider';

const node: PreloadableConcreteRequest<IssueTransitionModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bcbf748546e6d06895c02f12e112e0b3241c6d574e7955503cf520ffa998a0f4",
    "metadata": {},
    "name": "IssueTransitionModalQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": shouldFetchAppUserType_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcenableuimodificationsforitagentviewrelayprovider": enableUiModificationsForItAgentView_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider
    }
  }
};

export default node;
